import { h as head } from "../../../chunks/index2.js";
function _layout($$payload, $$props) {
  const { children } = $$props;
  head($$payload, ($$payload2) => {
    $$payload2.out.push(`<link rel="preload" href="/theJudiciary.jpeg" as="image"/> <link rel="preload" href="/kenyaLawLogo.png" as="image"/>`);
  });
  $$payload.out.push(`<div class="loginbg fixed inset-0 -z-10 svelte-c8gtcf"><div class="overlay absolute inset-0 backdrop-blur-[2px] svelte-c8gtcf"></div></div> <div class="flex min-h-screen items-center justify-center"><main class="w-1/3 min-w-72 overflow-y-auto rounded-sm bg-white p-6 shadow-lg"><div class="mb-4 flex justify-start"><a href="/"><img src="/kenyaLawLogo.png" alt="Logo" class="h-10"/></a></div> `);
  children?.($$payload);
  $$payload.out.push(`<!----></main></div>`);
}
export {
  _layout as default
};
